module.exports = __webpack_public_path__ + "static/media/Galeri_22.27e08b84.jpg";